import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { checkFieldsValidity } from '../../shared/index';
import { ManageAuctionFeesService } from '../manage-auction-fees.service';
import { Listbox } from 'primeng/listbox';
import { Table } from 'primeng/table';
import { AuctionFeeChangeLogType } from '../models/AuctionFees'

@Component({
  selector: 'app-change-log-auction-fees',
  templateUrl: './change-log-auction-fees.component.html',
  styleUrls: ['./change-log-auction-fees.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ChangeLogAuctionFeesComponent implements OnInit {

  @Output() closeDialog = new EventEmitter<boolean>();
  @Input() showDialog: boolean;
  @ViewChild('dt') table: Table;

  changeLogForm: FormGroup;
  minDate: Date;
  maxDate: Date;
  formSubmitted: boolean;
  disableChangeLogForm: boolean;
  changedBy: any[];
  loanType:any[];
  uniqueClientIds: any[];
  feeType: any[];
  typeOfSale: any[];
  feeAmount: any [];
  data: any[];
  showChangeByCheckBox: boolean = true;
  disableChangedCheckBox: boolean = false;
  showUniqueClientIdCheckBox: boolean = true;
  disableuniqueClientIdCheckBox: boolean = false;
  showLoanTypeCheckBox: boolean = true;
  disableLoanTypeCheckBox: boolean = false;
  showTypeOfSaleCheckBox: boolean = true;
  disableTypeOfSaleCheckBox: boolean = false;
  showFeeTypeCheckBox: boolean = true;
  disableFeeTypeCheckBox: boolean = false;
  showFeeAmountCheckBox: boolean = true;
  disableFeeAmountCheckBox: boolean = false;
  showChangedbyFilter: boolean = true;
  showUniqueClientIdFilter: boolean = true;
  showLoanTypeFilter: boolean = true;
  showTypeOfSaleFilter: boolean = true;
  showFeeTypeFilter: boolean = true;
  showFeeAmountFilter: boolean = true;

  selectedFeeAmount: any[];
  selectedFeeType: any[];
  selectedLoanType: any[];
  selectedClientId:any[];
  selectedChangedByUsers:any[];
  selectedTypeOfSale: any[];
  reqParams: AuctionFeeChangeLogType;
  records: any;
  loading: boolean;
  cols: { field: string; header: string; showInHeader: boolean; }[];

  constructor(private manageAuctionFeesService: ManageAuctionFeesService) { }

  ngOnInit() {
   // this.changedBy = [{ name: 'Loading..', code: 'Loading..' }];
    this.changedBy = [{ name: 'Loading..', code: 'Loading..' }];
    this.loanType = [{ name: 'Loading..', code: 'Loading..' }];
    this.feeType = [{ name: 'Loading..', code: 'Loading..' }];
    this.typeOfSale  = [{ name: 'Loading..', code: 'Loading..' }];
    this.feeAmount  = [{ name: 'Loading..', code: 'Loading..' }];
    this.uniqueClientIds  = [{ name: 'Loading..', code: 'Loading..' }];

    this.formSubmitted = false;
    this.changeLogForm = new FormGroup({
      ChangedBy: new FormControl('', null),
      FeeType: new FormControl('', null),
      UniqueClientID: new FormControl('', null),
      LoanType: new FormControl('', null),
      TypeOfSale: new FormControl('', null),
      FeeAmount: new FormControl('', null),
      ToDate: new FormControl('', null),
      FromDate: new FormControl('', null)
    }, checkFieldsValidity(Validators.required));

    this.formControlValueChanged();
   
    this.manageAuctionFeesService.getChangeLogSelectorsData().subscribe(res => {
      res.data[0].ChangedBy.length == 0 ? (
        this.changedBy = [{ name: 'No data', Code: 'No data' }], 
        this.showChangeByCheckBox = false, 
        this.disableChangedCheckBox = true, 
        this.showChangedbyFilter = false
        ) : (this.changedBy = res.data[0].ChangedBy);
      res.data[0].TypeOfSale.length == 0 ? (
        this.typeOfSale = [{ name: 'No data', Code: 'No data' }], 
        this.showTypeOfSaleCheckBox = false, 
        this.disableTypeOfSaleCheckBox = true, 
        this.showTypeOfSaleFilter = false
        ) : (this.typeOfSale = res.data[0].TypeOfSale);
      res.data[0].FeeAmount.length == 0 ? (
        this.feeAmount = [{ name: 'No data', Code: 'No data' }], 
        this.showFeeAmountCheckBox = false, 
        this.disableFeeAmountCheckBox = true, 
        this.showFeeAmountFilter = false
        ) : (this.feeAmount = res.data[0].FeeAmount);
      res.data[0].FeeType.length == 0 ? (
        this.feeType = [{ name: 'No data', Code: 'No data' }], 
        this.showFeeTypeCheckBox = false, 
        this.disableFeeTypeCheckBox = true, 
        this.showFeeTypeFilter = false
        ) : (this.feeType = res.data[0].FeeType);
      res.data[0].UniqueClientId.length == 0 ? (
        this.uniqueClientIds = [{ name: 'No data', Code: 'No data' }], 
        this.showUniqueClientIdCheckBox= false, 
        this.disableuniqueClientIdCheckBox = true, 
        this.showUniqueClientIdFilter = false
        ) : (this.uniqueClientIds = res.data[0].UniqueClientId);
      res.data[0].LoanType.length == 0 ? (
        this.loanType = [{ name: 'No data', Code: 'No data' }], 
        this.showLoanTypeCheckBox= false, 
        this.disableLoanTypeCheckBox = true, 
        this.showLoanTypeFilter = false
        ) : (this.loanType = res.data[0].LoanType);
    }); 

    this.cols = [
      { field: 'CRUDDate', header: 'Changed Date', showInHeader: true },
      { field: 'ChangeByName', header: 'Changed By', showInHeader: true },
      { field: 'AuctionFeesMatrixId', header: 'Auction Matrix ID', showInHeader: false },
      { field: 'AuctionFeesMatrixAuditId', header: 'Auction Matrix Audit ID', showInHeader: false },
      { field: 'CurrentUniqueClientID', header: 'Unique Client Id', showInHeader: true },
      { field: 'PreviousUniqueClientID', header: 'Previous unique Client Id', showInHeader: false },
      { field: 'CurrentLoanType', header: 'Loan Type', showInHeader: false },
      { field: 'PreviousLoanType', header: 'Previous Loan Type', showInHeader: false },
      { field: 'CurrentTypeOfSale', header: 'Type Of Sale', showInHeader: false },
      { field: 'PreviousTypeOfSale', header: 'Previous Type Of Sale', showInHeader: false },
      { field: 'CurrentFeeType', header: 'Fee Type', showInHeader: false },
      { field: 'PreviousFeeType', header: 'Previous Fee Type', showInHeader: false },
      { field: 'CurrentFeeAmount', header: 'Fee Amount', showInHeader: false },
      { field: 'PreviousFeeAmount', header: 'Previous Fee Amount', showInHeader: false },
      { field: 'CurrentIsActive', header: 'Current Is Active', showInHeader: false },
      { field: 'PreviousIsActive', header: 'Previous Is Active', showInHeader: false }
    ];
  }

  ngOnChanges() {
    this.resetForm();
  }

  resetForm() {
    if (this.changeLogForm != undefined) {
      this.changeLogForm.reset();
      this.data = [];
      this.formSubmitted = false;
      // this.listboxChangedBy.filterValue = '';
      // this.listboxStates.filterValue = '';
      // this.listboxTrsustee.filterValue = '';
    }

  }

  formControlValueChanged() {
    this.changeLogForm.get('FromDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.maxDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate > this.maxDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });

    this.changeLogForm.get('ToDate').valueChanges.subscribe(
      (newDate: Date) => {
        if (newDate != null && this.minDate == null) {
          this.disableChangeLogForm = true;
        } else if (newDate < this.minDate) {
          this.disableChangeLogForm = true;
        } else {
          this.disableChangeLogForm = false;
        }
      });
  }

  dialogHide() {
    this.closeDialog.emit(true);
  }

  setDateRange(days: number): void {
    let tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - days);
    this.minDate = tempDate;
    this.maxDate = new Date();
  }

  isPaginatorVisible(): boolean {
    return (this.data && this.data.length > 0) ? true : false;
  }

  formatDate(dateObj: Date): string {
    let current_datetime = dateObj;
    let formatted_date = current_datetime.getFullYear() + "-" + (current_datetime.getMonth() + 1) + "-" + current_datetime.getDate();
    return formatted_date;
  }

  formatParams(data): string {
    const formattedList = [];
    if (data) {
      data.map(item => {
        formattedList.push(item.code);
      });
    }
    return formattedList.toString();
  }

  onSubmitChangeLogForm(){
    this.reqParams = <AuctionFeeChangeLogType>{};
    this.reqParams.ChangedBy = this.formatParams(this.changeLogForm.value.ChangedBy);
    this.reqParams.FeeType = this.formatParams(this.changeLogForm.value.FeeType);
    this.reqParams.FeeAmount = this.formatParams(this.changeLogForm.value.FeeAmount);
    this.reqParams.TypeOfSale = this.formatParams(this.changeLogForm.value.TypeOfSale);
    this.reqParams.LoanType = this.formatParams(this.changeLogForm.value.LoanType);
    this.reqParams.UniqueClientID = this.formatParams(this.changeLogForm.value.UniqueClientID);
    this.reqParams.ToDate = this.changeLogForm.value.ToDate == null ? '' : this.formatDate(this.changeLogForm.value.ToDate);
    this.reqParams.FromDate = this.changeLogForm.value.FromDate == null ? '' : this.formatDate(this.changeLogForm.value.FromDate);
    this.loading =  true;
    this.formSubmitted = true;
    // Reset the paginator
    if(this.table)
    this.table.first = 0;

    this.manageAuctionFeesService.getChangeLogData(this.reqParams).subscribe(res => {
      console.log(res.data);
      this.data = res.data;
      this.records = res.meta.pagination.TotalRecords;
      this.loading = false;
    });
  }


}
